import { resolvePlanPrice } from './planAnnualPricing';

/** Preços SaaS da seção Marketing Digital — valores numéricos por moeda e ciclo. */

export const MARKETING_PLAN_PRICES = {
  start: {
    monthly: { BRL: 297, EUR: 49, USD: 59 },
    annual: { BRL: 2970, EUR: 490, USD: 590 }
  },
  growth: {
    monthly: { BRL: 697, EUR: 119, USD: 149 },
    annual: { BRL: 6970, EUR: 1190, USD: 1490 }
  },
  premium: {
    monthly: { BRL: 1497, EUR: 249, USD: 299 },
    annual: { BRL: 14970, EUR: 2490, USD: 2990 },
    plus: true
  }
};

export function getDefaultMarketingCurrency(language) {
  if (language === 'pt-BR') return 'BRL';
  if (language === 'pt-PT') return 'EUR';
  return 'USD';
}

const formatterCache = new Map();

function getNumberFormatter(locale) {
  if (!formatterCache.has(locale)) {
    formatterCache.set(
      locale,
      new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    );
  }
  return formatterCache.get(locale);
}

export function formatMarketingPlanPrice(amount, currency, cycle, opts = {}) {
  const { plus = false, language = 'pt-BR' } = opts;
  const suffix = plus ? '+' : '';
  const isEn = language === 'en' || (language && !String(language).startsWith('pt'));
  const periodMonthly = isEn ? '/mo' : '/mês';
  const periodAnnual = isEn ? '/yr' : '/ano';
  const period = cycle === 'monthly' ? periodMonthly : periodAnnual;

  const n = getNumberFormatter(
    currency === 'BRL' ? 'pt-BR' : currency === 'EUR' ? 'pt-PT' : 'en-US'
  ).format(amount);

  if (currency === 'BRL') return `R$ ${n}${period}${suffix}`;
  if (currency === 'EUR') return `${n} €${period}${suffix}`;
  return `US$ ${n}${period}${suffix}`;
}

export function getMarketingPlanPrice(planKey, currency, cycle, language) {
  return resolvePlanPrice({
    plan: MARKETING_PLAN_PRICES[planKey],
    currency,
    cycle,
    language,
    formatPrice: formatMarketingPlanPrice
  });
}
